export const setupSubnav = () => {
  const subnavContainer = document.querySelector('.lga_subnav') as HTMLElement;
  const subnav = document.querySelector('.sub-nav') as HTMLElement;
  const targetMenu = document.querySelector('.cm-menu') as HTMLElement;
  if (targetMenu) {
    const targetLi = targetMenu.lastElementChild as HTMLElement;
  }

  const mediaQuery = window.matchMedia('(max-width: 1151px)') as MediaQueryList;

  if (targetMenu && subnav) {
    mediaQuery.addEventListener('change', moveToHamburger);

    function moveToHamburger(e: MediaQueryListEvent | MediaQueryList) {
      if (e.matches) {
        targetMenu.appendChild(subnav);
      } else {
        if (subnavContainer) {
          subnavContainer.appendChild(subnav);
        }
      }
    }

    moveToHamburger(mediaQuery);
  }
};